import { useData } from '../../../../contexts/data-context/use-data';
import { ErrorSection } from '../../../../design-system/error-section/error-section';
import { Stack } from '../../../../design-system/stack/stack';
import { EmployeeView } from '../../../../types/entity-types';
import { EmployeeDrawer } from '../../components/add-employees-step/employee-drawer/employee-drawer';
import { useEmployee } from '../../hooks/use-employee';
import { useEmployeeFlow } from '../../hooks/use-employee-flow';
import { EmployeeTable } from './components/employee-table';

type EmployeeTabProps = {
  employees: EmployeeView[];
};

const EmployeeTab = ({ employees }: EmployeeTabProps) => {
  const { isEmployeeDrawerOpen, employeeDrawerMode, selectedEmployeeId, openEmployeeDrawer, closeEmployeeDrawer } =
    useEmployeeFlow();
  const { handleCreateEmployee, handleUpdateEmployee, isLoading } = useEmployee();

  const { data, error: dataError } = useData();

  if (!data) {
    return <ErrorSection error={dataError} />;
  }

  const legalEntityCountry = data.companies[0].legalEntity.country;
  const companyId = data.companies[0].id;

  return (
    <>
      <Stack align="stretch" className="mt-2 w-full" space={8}>
        <EmployeeTable
          employees={employees}
          onEditEmployee={(employeeId) => openEmployeeDrawer('EDIT', employeeId)}
          onAddEmployee={() => openEmployeeDrawer('ADD')}
        />
        <EmployeeDrawer
          employee={employees.find((employee) => employee.id === selectedEmployeeId)}
          isOpen={isEmployeeDrawerOpen}
          onClose={closeEmployeeDrawer}
          mode={employeeDrawerMode}
          selectedEmployeeId={selectedEmployeeId}
          legalEntityCountry={legalEntityCountry}
          companyId={companyId}
          onSave={(formData) => {
            if (employeeDrawerMode === 'ADD') {
              handleCreateEmployee(formData);
            } else if (selectedEmployeeId && employeeDrawerMode === 'EDIT') {
              handleUpdateEmployee(selectedEmployeeId, formData);
            }
            closeEmployeeDrawer();
          }}
          isSubmitting={isLoading}
        />
      </Stack>
    </>
  );
};

export default EmployeeTab;
